import React from "react";
import "./backDrop.css";
const BackDrop = (props) => {
  return (
    <div className="back-drop">
      <div>{props.children}</div>
    </div>
  );
};

export default BackDrop;
